import { render, staticRenderFns } from "./NeedList.vue?vue&type=template&id=50c39aa7"
import script from "./NeedList.vue?vue&type=script&lang=js"
export * from "./NeedList.vue?vue&type=script&lang=js"
import style0 from "./NeedList.vue?vue&type=style&index=0&id=50c39aa7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports